import React, { useEffect, useState } from "react";
import { notification, Alert } from "antd";
import settings from "../settings";
import { useAuth0 } from "@auth0/auth0-react";

const TelegramLogin = ({ message }) => {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [isRegistered, setIsRegistered] = useState(false);
  const [telegramId, setTelegramId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkRegistration = async () => {
      if (isAuthenticated) {
        try {
          const accessToken = await getAccessTokenSilently({
            authorizationParams: {
              audience: "https://valuedraw.com/api/v1",
              scope: "read:current_user",
            },
          });

          const response = await fetch(
            `${settings.API_BE_BASE_URL}/notifications/register/`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            },
          );

          if (response.ok) {
            const data = await response.json();
            setIsRegistered(true);
            setTelegramId(data.telegram_id);
          } else if (response.status === 404) {
            setIsRegistered(false);
          } else {
            notification.error({
              message: "Error",
              description: "Failed to check registration status.",
            });
          }
        } catch (error) {
          notification.error({
            message: "Error",
            description:
              "An error occurred while checking registration status.",
          });
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    checkRegistration();
  }, [isAuthenticated, getAccessTokenSilently]);

  useEffect(() => {
    if (!isRegistered && !isLoading) {
      const script = document.createElement("script");
      script.src = "https://telegram.org/js/telegram-widget.js?7";
      script.setAttribute("data-telegram-login", "ValueDrawBot");
      script.setAttribute("data-size", "large");
      script.setAttribute("data-userpic", "false");
      script.setAttribute("data-request-access", "write");
      script.setAttribute("data-onauth", "onTelegramAuth(user)");

      const widgetRoot = document.getElementById("telegram-widget");
      if (widgetRoot) {
        widgetRoot.appendChild(script);
      }

      return () => {
        const widgetRoot = document.getElementById("telegram-widget");
        if (widgetRoot) {
          widgetRoot.innerHTML = "";
        }
      };
    }
  }, [isRegistered, isLoading]);

  window.onTelegramAuth = async function (user) {
    console.log("Dati utente Telegram:", user);
    try {
      const accessToken = await getAccessTokenSilently({
        authorizationParams: {
          audience: "https://valuedraw.com/api/v1",
          scope: "read:current_user",
        },
      });

      const response = await fetch(
        `${settings.API_BE_BASE_URL}/notifications/register/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            telegram_id: user.id,
          }),
        },
      );

      if (response.ok) {
        notification.success({
          message: "Registration successful",
          description:
            "We will send you a registration confirmation on Telegram",
        });
        setIsRegistered(true);
        setTelegramId(user.id);
      } else {
        notification.error({
          message: "Error",
          description: "Failed to register with Telegram.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred during Telegram registration.",
      });
    }
  };

  if (isLoading) {
    return <></>;
  }

  return (
    <>
      {isRegistered ? (
        <Alert
          message={`Already linked with Telegram as user id ${telegramId}. Notifications will be sent there.`}
          type="success"
          showIcon
        />
      ) : (
        <div id="telegram-widget"></div>
      )}
    </>
  );
};

export default TelegramLogin;
